// assets/navbar.js

const hamburger = document.getElementById('hamburgerBtn');
const mobileMenu = document.getElementById('mobileMenu');
const header = document.getElementById('navbar');
const isHomePage = header ? header.classList.contains('text-white') : false; 

// --- Menu Logic ---
let isMenuOpen = false;

function toggleMenu() {
    isMenuOpen = !isMenuOpen;
    updateMenuState();
}

function updateMenuState() {
    if (isMenuOpen) {
        mobileMenu.classList.add('open');
        header.classList.add('scrolled'); // 强制黑字
        header.classList.remove('bg-transparent');
        header.classList.add('bg-white'); 
        header.classList.remove('text-white');
        header.classList.add('text-[#2b2b2b]');
        if(hamburger) hamburger.querySelectorAll('span').forEach(s => s.style.backgroundColor = '#2b2b2b');
    } else {
        mobileMenu.classList.remove('open');
        // 恢复初始状态
        if (isHomePage) {
            header.classList.remove('scrolled');
            header.classList.remove('bg-white', 'text-[#2b2b2b]');
            header.classList.add('bg-transparent', 'text-white');
        }
        checkScroll(); // 立即检查滚动状态
    }
}

if(hamburger) hamburger.addEventListener('click', toggleMenu);

// =================================================
// 核心修复：滚动隐藏/显示 (仅限产品页) & 颜色变换
// =================================================

let lastScrollY = window.scrollY;
let isHeaderForced = false; // 加购时强制显示的锁

function checkScroll() {
    const currentScrollY = window.scrollY;
    
    // 1. 判断当前是否为产品详情页
    // 大多数 Shopify 店铺的产品页 URL 都包含 '/products/'
    const isProductPage = window.location.pathname.includes('/products/');

    // 判断是否为移动端（手机 or 平板）
    const isMobileDevice = window.matchMedia("(max-width: 1024px)").matches;

    // --- Reveal Elements (保持不变) ---
    const revealElements = document.querySelectorAll('.reveal-text');
    revealElements.forEach(el => {
        if (el.getBoundingClientRect().top < window.innerHeight - 100) {
            el.classList.add('visible');
        }
    });

    // --- 颜色/背景逻辑 (保持不变) ---
    if (isHomePage && !isMenuOpen) {
        if (currentScrollY > 50) {
            header.classList.add('scrolled');
        } else {
            header.classList.remove('scrolled');
        }
        const color = (currentScrollY > 50) ? '#2b2b2b' : '#ffffff';
        if(hamburger) hamburger.querySelectorAll('span').forEach(s => s.style.backgroundColor = color);
    }

    // --- 隐藏/显示逻辑 (核心修改) ---

    // A. 如果是强制显示状态（加购时）或菜单打开时，必须显示
    if (isMenuOpen || isHeaderForced) {
        header.style.transform = 'translateY(0)';
        return;
    }

    // B. 非产品页：始终显示 (固定在顶部)
    if (!isProductPage && !isMobileDevice) {
        header.style.transform = 'translateY(0)';
        return;
    }

    // C. 产品页逻辑：下滑隐藏，上滑显示
    if (currentScrollY <= 60) {
        // 顶部缓冲区
        header.style.transform = 'translateY(0)';
        lastScrollY = currentScrollY;
        return;
    }

    if (currentScrollY > lastScrollY + 5) {
        // 下滑 -> 隐藏
        header.style.transform = 'translateY(-100%)';
    } else if (currentScrollY < lastScrollY - 5) {
        // 上滑 -> 显示
        header.style.transform = 'translateY(0)';
    }

    lastScrollY = currentScrollY;
}

// --- Resize Listener ---
window.addEventListener('resize', () => {
    const width = window.innerWidth;
    if (width >= 1024 && isMenuOpen) {
        isMenuOpen = false;
        updateMenuState();
    }
    checkScroll();
});

// --- Scroll Listener ---
window.addEventListener('scroll', checkScroll, { passive: true });
window.addEventListener('load', checkScroll);

// =================================================
// 全局方法：供 Product.js 调用
// =================================================
window.tempShowHeader = function() {
    isHeaderForced = true;
    header.style.transform = 'translateY(0)'; // 强制拉下来
    
    // 2.5秒后 (等飞入动画结束)，释放锁并重新检查
    setTimeout(() => {
        isHeaderForced = false;
        // 释放瞬间，如果用户还在下面，自动缩回去，保持沉浸感
        if (window.scrollY > 60) {
            header.style.transform = 'translateY(-100%)';
        }
    }, 2500);
};